import { Route, Routes, useLocation } from 'react-router-dom'
import { useEffect } from 'react'
import Home from './components/Home'
import About from './components/About'
import Contact from './components/Contact'
import Layout from './components/Layout'
import Portfolio from './components/Portfolio'
import Projects from './components/Projects'
import Resume from './components/Resume'
import AiAssistant from './components/AiAssistant'
import { ChatProvider } from './context/ChatContext'
import { ThemeProvider } from './context/ThemeContext'
import './App.scss'

function App() {
  const location = useLocation()

  useEffect(() => {
    if (typeof window.gtag === 'function') {
      window.gtag('config', 'G-WY8R209E7L', {
        page_path: location.pathname + location.search,
      })
    }
  }, [location])

  return (
    <ThemeProvider>
    <ChatProvider>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/experience" element={<Portfolio />} />
          <Route path="/resume" element={<Resume />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/ai" element={<AiAssistant />} />
        </Route>
      </Routes>
    </ChatProvider>
    </ThemeProvider>
  )
}

export default App
